// extracted by mini-css-extract-plugin
export default {"container":"dcc_conflictModal-container"};